import React from 'react'

import { Box, Grid, Radio, RadioGroup } from '@material-ui/core'

import ConnectAudio from './connect-audio'
import HlsComponent from './HlsComponent'
import useHooks from './hooks'

const Streamax = () => {
  const { videoRef, videoRef2, data, methods } = useHooks()
  return (
    <Box
      height="100vh"
      p={4}
      width="100vw"
      position="fixed"
      zIndex={9999}
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgcolor="white"
      flexDirection="column"
    >
      {data.videoSrc?.length > 0 && (
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <HlsComponent
              streamUrl={
                data.controls ? data.videoSrc?.[0]?.url : data.mediaUrl
              }
              videoRef={videoRef}
              autoplay
              controls={data.controls}
            />
          </Grid>
          <Grid item xs={6}>
            <HlsComponent
              streamUrl={
                data.controls ? data.videoSrc?.[1]?.url : data.mediaUrl
              }
              videoRef={videoRef2}
              autoplay
              controls={data.controls}
            />
          </Grid>
        </Grid>
      )}
      <Box
        display="flex"
        flexDirection="row"
        gridGap={3}
        alignItems="center"
        justifyContent="flex-start"
        width="100%"
      >
        <RadioGroup
          value={data.streamType}
          onChange={methods.handleStreamTypeChange}
        >
          <Box
            display="flex"
            flexDirection="row"
            gridGap={3}
            alignItems="center"
            justifyContent="flex-start"
            width="100%"
          >
            <Box display="flex" alignItems="center">
              <Radio value="1" />
              <Box>Monitor</Box>
            </Box>
            <Box display="flex" alignItems="center">
              <Radio value="2" />
              <Box>Talkback</Box>
            </Box>
          </Box>
        </RadioGroup>
        <ConnectAudio
          WS_URL={data.mediaUrl}
          handleStart={methods.handleStart}
        />
      </Box>
    </Box>
  )
}

export default Streamax
